import React, { useState } from 'react';
import { useToast } from '../../contexts/ToastContext';
import '../../styles/copy-button.css';

const CopyButton = ({ 
  text, 
  fontsize = 15,
  displayText = null, 
  className = '', 
  size = 'small',
  showText = true,
  successMessage = 'Copied to clipboard!',
  errorMessage = 'Failed to copy'
}) => {
  const { showSuccess, showError } = useToast();
  const [isAnimating, setIsAnimating] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation(); // Prevent event bubbling
    
    try {
      await navigator.clipboard.writeText(text);
      setIsAnimating(true);
      showSuccess(successMessage);
      
      // Reset animation after 300ms
      setTimeout(() => setIsAnimating(false), 300);
    } catch (error) {
      console.error('Failed to copy:', error);
      showError(errorMessage);
    }
  };

  return (
    <div className={`copy-container ${className}`}>
      {showText && (
        <span className="copy-text" style={{fontSize:fontsize}}>
          {displayText || text}
        </span>
      )}
      <button
        className={`copy-button ${size} ${isAnimating ? 'copying' : ''}`}
        onClick={handleCopy}
        title={`Copy ${displayText || text}`}
        type="button"
      >
        {isAnimating ? '✓' : '📋'}
      </button>
    </div>
  );
};

// Utility component for inline address copying
export const CopyableAddress = ({ 
  address, 
  truncate = true, 
  truncateLength = 8,
  className = '',
  prefix = ''
}) => {
  const displayAddress = truncate 
    ? `${address.slice(0, truncateLength)}...${address.slice(-truncateLength)}`
    : address;

  return (
    <CopyButton
      text={address}
      displayText={`${prefix}${displayAddress}`}
      className={`copyable-address ${className}`}
      successMessage={`${prefix ? prefix + ' ' : ''}Address copied!`}
    />
  );
};

// Utility component for mint address copying
export const CopyableMint = ({ 
  mintAddress, 
  truncate = true, 
  truncateLength = 6,
  className = '',
  fontsize=15
}) => {
  return (
    <CopyableAddress
      address={mintAddress}
      truncate={truncate}
      truncateLength={truncateLength}
      className={`copyable-mint ${className}`}
      prefix=""
      fontsize={fontsize}
    />
  );
};

export default CopyButton;